import useFetch from '@hooks/useFetch';

const useGoalSpecificCities = (goalUID) => {
  const key = `v1/asgard/centre/offline/cities?goal_uid=${goalUID}`;
  const { data: cityData, isValidating, ...rest } = useFetch(key);
  const activeCities =
    cityData?.filter((city) => city?.status === 'Active') || [];
  let defaultCentre = null;
  for (let i = 0; i < activeCities?.length; i += 1) {
    defaultCentre = activeCities[i].centres?.find((centre) => centre.isDefault);
    if (defaultCentre) break;
  }
  const isCentreAvailable = activeCities?.length > 0 || false;
  return {
    cityData,
    isValidating,
    activeCities,
    isCentreAvailable,
    defaultCentreUid: defaultCentre?.uid,
    ...rest
  };
};

export default useGoalSpecificCities;
